export const StatusModeloMensagem = {
    Aprovado: 0,
    Pendente: 1,
    Rejeitado: 2,
  };
  

  
  export default StatusModeloMensagem;
  